export default __webpack_public_path__ + "static/icon4-8503d26a09d5cc0c3c8742ae0a95b748.png";